// @see https://tailwindcss.com/docs/responsive-design
export const XS_VIEWPORT = 492;
export const SM_VIEWPORT = 640;
export const MD_VIEWPORT = 768;
export const LG_VIEWPORT = 1024;
export const XL_VIEWPORT = 1280;
export type ViewportType =
  | typeof XS_VIEWPORT
  | typeof SM_VIEWPORT
  | typeof MD_VIEWPORT
  | typeof LG_VIEWPORT
  | typeof XL_VIEWPORT;
